import { Highscores } from "../components/highscores/highscores";

export function HighscoresPage(): JSX.Element {
  return <Highscores />;
}
